import { LayoutAddiScreenTabletMin } from '@addi/foundation/dist/web/layout';
import styled from 'styled-components';
export const MINIMUM_WIDTH_RESPOSIVENESS = '1350px';
export const TABLET_WIDTH_RESPOSIVENESS = '1400px';
export const ComponentContainer = styled.div `
  position: relative;
  width: 100%;
  box-sizing: border-box;
`;
export const CarouselContainer = styled.div.attrs({ className: 'embla__container' }) `
  display: flex;
`;
export const styleSlideStores = {
    position: 'relative',
    flex: '0 0 272px',
};
export const Div = styled.div `
  padding-left: calc(40% - 612px);
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const Content = styled.div ``;
export const Embla = styled.div `
  position: 'relative';
`;
export const EmblaViewport = styled.div `
  overflow: hidden;
`;
export const EmblaContainer = styled.div `
  display: flex;
  will-change: transform;
  margin-left: -1rem;
  .item-child:first-child {
    padding-left: 40px;
    @media (min-width: ${TABLET_WIDTH_RESPOSIVENESS}) {
      padding-left: ${({ sidePadding }) => (sidePadding ? sidePadding : '0')};
    }
  }
`;
export const Slide = styled.div `
  flex: 0 0 auto;
  position: relative;
  padding-right: ${({ spaceBetweenItems }) => spaceBetweenItems && spaceBetweenItems.mobile ? spaceBetweenItems.mobile : '1rem'};
  counter-increment: embla;
  @media (min-width: ${LayoutAddiScreenTabletMin}) {
    padding-right: ${({ spaceBetweenItems }) => spaceBetweenItems && spaceBetweenItems.tablet ? spaceBetweenItems.tablet : '1rem'};
  }
  @media (min-width: ${MINIMUM_WIDTH_RESPOSIVENESS}) {
    padding-right: ${({ spaceBetweenItems }) => spaceBetweenItems && spaceBetweenItems.desktop ? spaceBetweenItems.desktop : '3rem'};
  }
`;
export const SlideInner = styled.div `
  flex: 0 0 auto;
  position: relative;
  counter-increment: embla;
  padding-bottom: 0;
  height: 100%;
`;
export const ButtonsAligner = styled.div `
  width: 100%;
  position: relative;
  top: ${(props) => (props.verticalAlign ? props.verticalAlign : '-150px')};
  box-sizing: border-box;
  padding: 0 50px;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const PrevButton = styled.div `
  visibility: ${(props) => (!props.prevBtnEnabled ? 'hidden' : 'visible')};
  cursor: pointer;
  transition: transform 0.2s;
  float: left;
  width: 56px;
  height: 56px;
  .hover {
    display: none;
  }
  .normal {
    display: block;
  }
  :hover {
    .hover {
      display: block;
    }
    .normal {
      display: none;
    }
  }
`;
export const NextButton = styled.div `
  visibility: ${(props) => (!props.nextBtnEnabled ? 'hidden' : 'visible')};
  cursor: pointer;
  transition: transform 0.2s;
  float: right;
  width: 56px;
  height: 56px;
  .hover {
    display: none;
  }
  .normal {
    display: block;
  }
  :hover {
    .hover {
      display: block;
    }
    .normal {
      display: none;
    }
  }
`;
export const Img = styled.img `
  transform: ${(props) => (props.right ? 'scaleX(-1)' : '')};
  width: 100%;
`;
//# sourceMappingURL=carousel-horizontal.styles.js.map